import { render, staticRenderFns } from "./LayoutMain.vue?vue&type=template&id=678cde70&scoped=true"
import script from "./LayoutMain.vue?vue&type=script&lang=js"
export * from "./LayoutMain.vue?vue&type=script&lang=js"
import style0 from "./LayoutMain.vue?vue&type=style&index=0&id=678cde70&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678cde70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('678cde70')) {
      api.createRecord('678cde70', component.options)
    } else {
      api.reload('678cde70', component.options)
    }
    module.hot.accept("./LayoutMain.vue?vue&type=template&id=678cde70&scoped=true", function () {
      api.rerender('678cde70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/LayoutMain.vue"
export default component.exports